///<reference path="./typings.d.ts" />
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
platformBrowserDynamic().bootstrapModule(AppModule, { preserveWhitespaces: true });
//# sourceMappingURL=main-aot.js.map